import { Stack, TextField } from 'braid-design-system';
import { useState } from 'react';
import { InlineCode } from 'scoobie';
import { useDebounce } from 'use-debounce';
import { JobCategorySelect } from 'wingman-fe';

import { SectionHeadingLink } from './SectionHeadingLink/SectionHeadingLink.tsx';

import { CopyableText } from '#src/components/CopyableText/CopyableText.tsx';
import { useEnvironmentConfig } from '#src/hooks/environment.tsx';

export const JobCategorySelectSection = () => {
  const { seekAnzSchemeId } = useEnvironmentConfig();

  const [oid, setOid] = useState<string>();
  const [rawLocation, setLocation] = useState('');
  const [positionLocation] = useDebounce(rawLocation.trim(), 1000);

  return (
    <Stack space="large">
      <SectionHeadingLink href="/use-cases/job-posting/job-categories#option-2-provide-dropdown-fields">
        Job category select
      </SectionHeadingLink>

      <TextField
        onChange={(event) => setLocation(event.currentTarget.value)}
        id="seek-job-category-select-position-location"
        label="Location ID"
        message={
          <>
            e.g.{' '}
            <InlineCode>{seekAnzSchemeId}:location:seek:2FqwWaaMV</InlineCode>
          </>
        }
        value={rawLocation}
      />
      <JobCategorySelect
        id="seek-job-category-select"
        onSelect={(category) => setOid(category.id.value)}
        schemeId={seekAnzSchemeId}
        positionProfile={
          positionLocation
            ? {
                positionLocation: [positionLocation],
              }
            : undefined
        }
        context={{ criticalErrorsOnlyTracking: true }}
      />

      {oid ? <CopyableText inlineCode>{oid}</CopyableText> : null}
    </Stack>
  );
};
